import React from 'react';

import { Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import ClientEncounterList from '../components/encounter/ClientEncounterList';

const Dashboard: React.FC = () => {
  return (
    <Stack gap="lg">
      <ClientEncounterList 
        title="Encounters From Past Week"
        titleAction={
          <Text
            c="blue"
            component={Link}
            size="sm"
            style={{
              textDecoration: 'none',
              color: 'inherit'
            }}
            to="/encounters"
          >
            See All
          </Text>
        }
      />
    </Stack>
  );
};

export default Dashboard;
